var map = {
	"./de/btn-view.png": "ZjjA",
	"./en/btn-view.png": "USgz",
	"./es/btn-view.png": "8Chc",
	"./fr/btn-view.png": "4ksG",
	"./ja/btn-view.png": "o8d1",
	"./ko/btn-view.png": "3Ere",
	"./pt/btn-view.png": "x2Eu",
	"./ru/btn-view.png": "gluM",
	"./tc/btn-view.png": "7h3Q",
	"./th/btn-view.png": "Gioy"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "AHpa";